<template>
    <!-- show my referral link -->
    <div class="row my-3">
        <div class="col-12">
            <div class="card bg-white">
                <div class="card-body py-2">
                    <div class="clearfix">
                        <div class="float-left">
                            <h5 class="text-dark-green nav-settings-head m-0">
                                <span v-if="!showReferral" @click="showReferral = true" class="clickable">My ReferralLink</span>
                                <span v-else @click="showReferral = false" class="clickable">My ReferralLink</span>
                            </h5>
                        </div>
                        <div class="float-right clickable">
                            <small v-if="!showReferral" @click="showReferral = true">
                                Show <i class="fas fa-eye"></i>
                            </small>
                            <small v-else @click="showReferral = false">
                                Hide <i class="fas fa-eye-slash"></i>
                            </small>
                        </div>
                    </div>

                    <div v-if="showReferral">
                        <!-- show referral url -->
                        <div v-if="myReferralLink">
                            <small>
                                <span @click.prevent="copyURL" class="clickable">Click me to copy your referral link</span>
                            </small>
                            <div class="add-ellipsis">
                                <span v-if="!copied" class="referral-link mr-2" ref="myRefLink">{{myReferralLink}}</span>
                                <span v-if="copied" class="referral-link">Copied!</span>
                                <i v-else @click.prevent="copyURL" title="click to copy your referral link" 
                                class="far fa-copy text-dark-green fa-lg clickable"></i>
                            </div>
                        </div>
                        <!-- show notations -->
                        <div v-if="showNotations" class="mt-2">
                            <small>1. aTrue Member - User must confirm their email address</small> <br>
                            <small>2. Posted Item - User must post at least one item</small> <br>
                            <small>
                                3. Earned - 
                                <span><i class="fas fa-square text-danger"></i></span> Not Payable
                                <span><i class="fas fa-square text-dark-green"></i></span> Payable
                            </small> <br>
                            <small>4. Paid - Ensures you got paid for your referral</small>
                        </div>
                        <!-- close window -->
                        <p class="m-0">
                            <small v-if="showNotations" @click.prevent="showNotations = false" class="clickable text-danger">
                                <i class="fas fa-times"></i> Hide Notations
                            </small>
                            <small v-else @click.prevent="showNotations = true" class="clickable">
                                <i class="fas fa-receipt"></i> Show Notations
                            </small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { copyTextFxn } from '@/store/dry'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "ReferralLink",
    data() {
        return {
            showReferral: false,
            showNotations: false,
            copied: false
        }
    },
    methods: {
        copyURL() {
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 1000)
            copyTextFxn(this.$refs.myRefLink.innerText)
        }
    },
    computed: {
        ...mapGetters(['user']),
        myReferralLink() {
            if(this.user && this.user.userHandle){
                return `${process.env.VUE_APP_CLT_URL}/${this.user.userHandle}/refer-a-friend`
            }
            return false
        },
    },
    created() {
        this.$emit('update:layout', LayoutUser);
    }
}
</script>